function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { cubicBezier, presets } from '@bydesign-ui/utils';
import { usePrevProp, useRefCallback, useSingleton, useUpdate } from '@bydesign-ui/hooks';
import React, { useEffect, useRef } from 'react';
export function useChildrenEnterLeave(children) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _options$childRefKey = options.childRefKey,
      childRefKey = _options$childRefKey === void 0 ? 'ref' : _options$childRefKey,
      disabled = options.disabled,
      duration = options.duration,
      enterChildProps = options.enterChildProps,
      ignoreInitialRender = options.ignoreInitialRender,
      leaveChildProps = options.leaveChildProps,
      moveChildProps = options.moveChildProps,
      onFrameAnimationEnd = options.onFrameAnimationEnd,
      _options$skipChildWit = options.skipChildWithoutRef,
      skipChildWithoutRef = _options$skipChildWit === void 0 ? true : _options$skipChildWit,
      timingFunction = options.timingFunction,
      _options$updateAfterA = options.updateAfterAnimation,
      updateAfterAnimation = _options$updateAfterA === void 0 ? true : _options$updateAfterA;

  var _getEnterLeaveMoveTic = getEnterLeaveMoveTick(options),
      enterTick = _getEnterLeaveMoveTic.enterTick,
      leaveTick = _getEnterLeaveMoveTic.leaveTick,
      moveTick = _getEnterLeaveMoveTic.moveTick;

  var getEnterChildProps = isNotPropsGetter(enterChildProps) ? function () {
    return enterChildProps;
  } : enterChildProps;
  var getLeaveChildProps = isNotPropsGetter(leaveChildProps) ? function () {
    return leaveChildProps;
  } : leaveChildProps;
  var getMoveChildProps = isNotPropsGetter(moveChildProps) ? function () {
    return moveChildProps;
  } : moveChildProps;
  var forceUpdate = useUpdate();
  var initialRender = useRef(true);
  var leavingKeys = useSingleton(function () {
    return new Set();
  });
  var enteringKeys = useSingleton(function () {
    return new Set();
  });
  var movingKeys = useSingleton(function () {
    return new Map();
  });
  var childMap = new Map();
  var prevChildMap = usePrevProp(childMap, function () {
    return false;
  })[1];
  var domNodeMap = useSingleton(function () {
    return new Map();
  });
  var handleFrameAnimationEnd = useRefCallback(function () {
    onFrameAnimationEnd === null || onFrameAnimationEnd === void 0 ? void 0 : onFrameAnimationEnd();

    if (updateAfterAnimation) {
      forceUpdate();
    }
  });
  useEffect(function () {
    initialRender.current = false;
  }, []);

  if (disabled || ignoreInitialRender && initialRender.current) {
    React.Children.toArray(children).forEach(function (child, index) {
      if (React.isValidElement(child) && child.key) {
        childMap.set(child.key, [index, child]);
      }
    });
    return [children, function () {
      return function () {
        return void 0;
      };
    }];
  }

  var childRef = function childRef(key) {
    return function (element) {
      if (element) {
        domNodeMap.set(key, _objectSpread(_objectSpread({}, domNodeMap.get(key)), {}, {
          element: element
        }));
      } else if (!enteringKeys.has(key) && !leavingKeys.has(key) && !movingKeys.has(key)) {
        domNodeMap.delete(key);
      }
    };
  };

  var handleClone = function handleClone(child, index) {
    if (!React.isValidElement(child) || !child.key) {
      return child;
    }

    var key = child.key;
    var exists = prevChildMap !== childMap && prevChildMap.get(key);
    var moved = exists && exists[0] !== index;
    var rewriteProps = !exists ? getEnterChildProps(child.props, key) : moved ? getMoveChildProps(child.props, key, exists[0] - index) : {};

    if (exists) {
      prevChildMap.delete(key);
      moved && movingKeys.set(key, exists[0] - index);
    } else {
      leavingKeys.delete(key);
      enteringKeys.add(key);
    }

    var refKey = typeof childRefKey === 'function' ? childRefKey(child) : childRefKey;
    var reactNode = React.cloneElement(child, _objectSpread(_objectSpread({}, rewriteProps), refKey ? _defineProperty({}, refKey, childRef(key)) : {}));
    childMap.set(key, [index, reactNode]);
    return reactNode;
  };

  var clonedChildren = React.Children.toArray(children).map(handleClone);

  if (prevChildMap !== childMap) {
    prevChildMap.forEach(function (_ref2, key) {
      var _ref3 = _slicedToArray(_ref2, 2),
          index = _ref3[0],
          child = _ref3[1];

      leavingKeys.add(key);
      enteringKeys.delete(key);
      var refKey = typeof childRefKey === 'function' ? childRefKey(child) : childRefKey;
      var reactNode = React.cloneElement(child, _objectSpread(_objectSpread({}, getLeaveChildProps(child.props, key)), refKey ? _defineProperty({}, refKey, childRef(key)) : {}));
      clonedChildren.splice(index, 0, reactNode);
    });
  }

  if (!leavingKeys.size && !enteringKeys.size && !movingKeys.size) {
    return [children, function () {
      return function () {
        return void 0;
      };
    }];
  }

  if (duration === undefined || !enterTick && !leaveTick && !moveTick) {
    return [children, function () {
      return function () {
        return void 0;
      };
    }];
  }

  var durations = getDuration(duration);
  var timings = getTimingFunction(timingFunction);

  var tick = function tick() {
    var now = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : performance.now();

    if (enterTick) {
      enteringKeys.forEach(function (key) {
        var domNode = getDomNode(domNodeMap, enteringKeys, key, skipChildWithoutRef);

        var _getPercent = getPercent(domNode, now, durations, timings, 'enter'),
            percent = _getPercent.percent,
            finished = _getPercent.finished;

        if (finished) {
          enteringKeys.delete(key);

          if (!domNode.element) {
            domNodeMap.delete(key);
          }
        }

        if (domNode.element) {
          domNode.memo = enterTick(domNode.element, percent, domNode.memo, key);
        }
      });
    } else {
      enteringKeys.clear();
    }

    if (leaveTick) {
      leavingKeys.forEach(function (key) {
        var domNode = getDomNode(domNodeMap, leavingKeys, key, skipChildWithoutRef);

        var _getPercent2 = getPercent(domNode, now, durations, timings, 'leave'),
            percent = _getPercent2.percent,
            finished = _getPercent2.finished;

        if (finished) {
          leavingKeys.delete(key);

          if (!domNode.element) {
            domNodeMap.delete(key);
          }
        }

        if (domNode.element) {
          domNode.memo = leaveTick(domNode.element, percent, domNode.memo, key);
        }
      });
    } else {
      leavingKeys.clear();
    }

    if (moveTick) {
      movingKeys.forEach(function (moved, key) {
        var domNode = getDomNode(domNodeMap, movingKeys, key, skipChildWithoutRef);

        var _getPercent3 = getPercent(domNode, now, durations, timings, 'move'),
            percent = _getPercent3.percent,
            finished = _getPercent3.finished;

        if (finished) {
          movingKeys.delete(key);

          if (!domNode.element) {
            domNodeMap.delete(key);
          }
        }

        if (domNode.element) {
          domNode.memo = moveTick(domNode.element, percent, moved, domNode.memo, key);
        }
      });
    } else {
      movingKeys.clear();
    }

    if (!enteringKeys.size && !leavingKeys.size && !movingKeys.size) {
      tick.frame = undefined;
      handleFrameAnimationEnd();
    } else {
      tick.frame = requestAnimationFrame(tick);
    }
  };

  var start = function start() {
    tick.frame = requestAnimationFrame(tick);
    return function () {
      tick.frame !== undefined && cancelAnimationFrame(tick.frame);
    };
  };

  return [clonedChildren, start];
}

function getDomNode(map, keys, key, skipChildWithoutRef) {
  var domNode = map.get(key);

  if (!domNode) {
    domNode = {};
    map.set(key, domNode);
  }

  if (!domNode.element) {
    if (skipChildWithoutRef) {
      map.delete(key);
      keys.delete(key);
    }
  } else if (!domNode.element.isConnected) {
    map.delete(key);
    keys.delete(key);
  }

  return domNode;
}

function getPercent(domNode, now, durations, timings, type) {
  var _a;

  domNode.startTime = (_a = domNode.startTime) !== null && _a !== void 0 ? _a : now;
  var cost = now - domNode.startTime;
  var finished = cost >= durations[type];
  var percent = finished ? 1 : timings[type](cost / durations[type]);
  return {
    percent: percent,
    finished: finished
  };
}

function getEnterLeaveMoveTick(options) {
  var enter = options.enterTick,
      leave = options.leaveTick,
      moveTick = options.moveTick;
  var enterTick = enter !== null && enter !== void 0 ? enter : leave && function (a, b, c, d) {
    return leave(a, 1 - b, c, d);
  };
  var leaveTick = leave !== null && leave !== void 0 ? leave : enter && function (a, b, c, d) {
    return enter(a, 1 - b, c, d);
  };
  return {
    enterTick: enterTick,
    leaveTick: leaveTick,
    moveTick: moveTick
  };
}

function isNotPropsGetter(value) {
  return typeof value !== 'function';
}

function getTimingFunction() {
  var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var defaultMap = {
    enter: presets.easeOut,
    leave: presets.easeIn,
    move: presets.easeInOut
  };

  if (typeof value === 'string') {
    return {
      enter: presets[value],
      leave: presets[value],
      move: presets[value]
    };
  }

  if (Array.isArray(value)) {
    var getter = cubicBezier.apply(void 0, _toConsumableArray(value));
    return {
      enter: getter,
      leave: getter,
      move: getter
    };
  }

  return Object.keys(value).reduce(function (prev, curr) {
    var item = value[curr];
    return _objectSpread(_objectSpread({}, prev), {}, _defineProperty({}, curr, typeof item === 'string' ? presets[item] : cubicBezier.apply(void 0, _toConsumableArray(item))));
  }, defaultMap);
}

function getDuration() {
  var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  return typeof value === 'number' ? {
    enter: value,
    leave: value,
    move: value
  } : value;
}

if (typeof window !== 'undefined') {
  if (!('isConnected' in Node.prototype)) {
    Object.defineProperty(Node.prototype, 'isConnected', {
      get: function get() {
        return !this.ownerDocument || !(this.ownerDocument.compareDocumentPosition(this) & this.DOCUMENT_POSITION_DISCONNECTED);
      }
    });
  }
}